import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import User from 'models/User';

import { profileGet } from 'store/modules/user/actions';
import { State as ReduxState } from 'store/state';

import Component from './component';

export interface Props extends ParentProps {
    state?: {
        user?: User;
    };
    actions?: {
        profileGet: Function;
    }
}

export interface ParentProps {
    route: string;
    variables: {};
    disabled?: boolean;
    iconOnly?: boolean;
}

const mapStateToProps = (state: ReduxState, ownProps?: Props): object => {
    return {
        state: {
            user: state.user.profile,
        },
    };
};

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            profileGet: bindActionCreators(profileGet, dispatch),
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);